export default __webpack_public_path__ + "static/media/HomeActive.7c8b903d.svg";